<mat-form-field [formGroup]="yearForm">
  <mat-label class="personal-data__question">{{ label | translate }}</mat-label>
  <input matInput [matDatepicker]="dp" formControlName="year" required
         [min]="minYearDate"
         (dateInput)='emitYear($event.value)'
         (dateChange)='emitYear($event.value)'>
  <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp
                  startView="multi-year"
                  (yearSelected)="setYear($event, dp)"
                 >
  </mat-datepicker>
  @if (yearForm.get("year")?.invalid) {
    <mat-error>{{ 'personalData.validYear' | translate }}</mat-error>
  }
</mat-form-field>
